import React from 'react'
import ReactDOM from 'react-dom'
import { Loader } from '@calendly/ui/components/loader'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { Settings } from 'services/settings'

class PayButton extends React.Component {
  state = {
    loading: true
  }

  onRendered = () => this.setState({ loading: false })

  onCreateOrder = (data, actions) => this.props.onCreateOrder(data, actions)

  onApprove = (data, actions) => this.props.onApprove(data, actions)

  onError = (data, actions) => this.props.onError(data, actions)

  render() {
    // paypal is loaded in a script tag (src=https://www.paypal.com/sdk/js?...) before we set up the PaypalForm, which contains this button
    const Button = window.paypal.Buttons.driver('react', {
      React,
      ReactDOM,
    })

    return (
      <>
        <div className={this.getWrapperClassName()} style={this.getWrapperStyle()}>
          <Button
            style={PayButton.getButtonStyle()}
            env={Settings.paypal.env}
            client={{ [Settings.paypal.env]: Settings.paypal.client_id }}
            locale={this.props.locale}
            commit={this.props.commit}
            onRendered={this.onRendered}
            createOrder={this.onCreateOrder}
            onApprove={this.onApprove}
            onError={this.onError}
          />
        </div>
        {this.state.loading ? <Loader /> : undefined}
      </>
    )
  }

  getWrapperClassName() {
    return classNames(
      'paypal-frame-wrapper',
      this.props.className,
    )
  }

  getWrapperStyle() {
    if (this.state.loading) {
      return { display: 'none' }
    }
    return { display: 'block' }
  }

  static getButtonStyle() {
    return {
      layout: 'horizontal',
      color: 'gold',
      shape: 'rect',
      label: 'pay',
      tagline: false,
    }
  }
}

PayButton.propTypes = {
  onCreateOrder: PropTypes.func.isRequired,
  onApprove: PropTypes.func.isRequired,
  commit: PropTypes.bool,
  locale: PropTypes.string,
  onError: PropTypes.func,
  className: PropTypes.string
}

PayButton.defaultProps = {
  commit: false,
  locale: 'en_US',
  onError: () => undefined,
  className: undefined
}

export default PayButton
